import * as React from 'react'

export const ScrollTopOnMount: React.FC = () => {
  React.useEffect(() => {
    setTimeout(() => {
      // in jest, there is no window (as there are no spoons either)
      if (window && window.scrollTo) {
        window.scrollTo(0, 0)
      }
    })
  }, [])

  return null
}
